import { TabsWithButtons } from "@cpj-ai/panel-npm-package";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { getCompanyDetailTabsConfigs } from "./tabsConfig";

interface ICompanyDetailTabsProps {
  refetchCompanyDetail: () => void;
}

const CompanyDetailTabs = ({ refetchCompanyDetail }: ICompanyDetailTabsProps) => {
  const [activeTab, setActiveTab] = useState("overview");
  const { id } = useParams();
  const tabConfigs = getCompanyDetailTabsConfigs(activeTab, refetchCompanyDetail, id);

  const handleSelectTab = (key: string) => {
    setActiveTab(key);
  };

  return (
    <div className="h-full overflow-y-auto">
      <TabsWithButtons
        classNames={{ container: "pt-5" }}
        tabData={tabConfigs}
        selectedKey={activeTab}
        variant="underlined"
        color="primary"
        showArrows
        onTabChange={handleSelectTab}
      />
    </div>
  );
};

export default CompanyDetailTabs;
